import type {DesignContributorInfo, DesignPermissionLevel} from '@Panels/share-panel/share-panel.types';
import type {InviteStateType} from '../invite-state/invite-state.types';

export interface ShareDesignAccessOptsProps {
  posterHashedId: string;
  designerContributorInfo: DesignContributorInfo;
  onPermissionLevelUpdate: (permissionLevel: DesignPermissionLevel, idUser?: number) => void;
  onRemoveUser: (idUser?: number) => void;
  onResendInvite: (email: string, inviteStateType: InviteStateType) => void;
  isMobile?: boolean;
  idDesignOwner?: number;
}

export enum ShareDesignAccessLoadingKeys {
  EDIT = 'edit',
  VIEW = 'view',
  REMOVE = 'remove',
}